<template>
    <div>
        <div class="mt-6">
            <div class="font-bold text-18 text-a-brown-502314 mb-5 mx-4">
                {{ deliveryStatusText }}
            </div>
            <template v-if="isDeliveryType">
                <div class="bg-a-brown-e7d7c1 p-4 relative timeline" :class="[isLoginAccount ? 'lg:rounded-b-10' : '']">
                    <div class="line absolute top-6 left-6"></div>

                    <div class="flex items-center mb-4 ">
                        <div class="flex-none">
                            <img class="mr-3 w-5 h-auto transform" src="@/assets/icon/ic-branch-bg-brown.svg" />
                        </div>
                        <div class="branch">Burger King - {{ localeCode == 1033 ? trackingOrder.branchNameEN : trackingOrder.branchName
                        }}</div>
                    </div>
                    <div class="flex items-start">
                        <div class="flex-none">
                            <img class="mr-3 w-4 h-auto transform translate-x-1px translate-y-1"
                                src="@/assets/icon/ic-destination-bg-brown.svg" />
                        </div>
                        <div class="text-a-red-d62300 address">{{ trackingOrder.address }}</div>
                    </div>
                </div>
            </template>
            <template v-else>
                <div class="bg-a-brown-e7d7c1 p-4 relative" :class="[isLoginAccount ? 'lg:rounded-b-10' : '']">
                    <div class="flex items-start">
                        <div class="flex-none">
                            <img class="mr-3 w-5 h-auto transform translate-y-1"
                                src="@/assets/icon/ic-branch-bg-brown.svg" />
                        </div>
                        <div>Burger King - {{ localeCode == 1033 ? trackingOrder.branchNameEN : trackingOrder.branchName
                        }}</div>
                    </div>
                </div>
            </template>
        </div>
    </div>

</template>
<script>
import { computed, inject } from 'vue'
import AuthStatusMixin from '@/mixin/AuthStatusMixin'
import { VendorStatusCode, DeliveryStatusCode } from '@/helper/StaticValue'

export default {
    name: 'DeliveryStatus',
    props: {},
    components: {},
    mixins: [AuthStatusMixin],
    emits: [],
    data: function () { return {} },
    setup: function () {
        const { lbl, localeCode } = inject("LocaleStore")
        const trackingOrder = inject("getTracking")
        const VendorStatus = VendorStatusCode

        const isDeliveryType = computed(() => {
            if (trackingOrder.value.orderType == "Delivery") {
                return true
            }

            return false
        })

        const deliveryStatusText = computed(() => {
            let text = ""
            switch (trackingOrder.value.deliveryStatus) {
                case DeliveryStatusCode.OnGoing:
                    text = lbl.value.myOrder.delivery.statusText.onGoing
                    break;
                case DeliveryStatusCode.Completed:
                    text = lbl.value.myOrder.delivery.statusText.completed
                    break;

                default:
                    text = lbl.value.myOrder.delivery.statusText.onGoing
                    break;
            }

            return text
        })

        return {
            localeCode,
            trackingOrder,
            VendorStatus,
            isDeliveryType,
            deliveryStatusText
        }
    },
}
</script>

<style scoped lang="scss">
@import "@/style/base/text.scss";
.timeline {
    .line {
        height: calc(100% - 48px);
        border-left: 1px dashed #502314;
    }
}
.branch {
    @extend %ellipsis-1;
}
.address {
    @extend %ellipsis-1;
}
</style>
